import { render } from "./CardColdEmail.vue?vue&type=template&id=cc293e94&scoped=true&lang=true"
import script from "./CardColdEmail.vue?vue&type=script&lang=js"
export * from "./CardColdEmail.vue?vue&type=script&lang=js"

import "./CardColdEmail.vue?vue&type=style&index=0&id=cc293e94&lang=css&scoped=true"
script.render = render
script.__scopeId = "data-v-cc293e94"

export default script